import { Injectable } from '@angular/core';

import { ignoreElementsTyped } from '@frontend/sports/common/core/utils/rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { NumpadDisplayService } from 'packages/sports/web/app/src/numpad/numpad-display.service';
import { uiStateSelector } from 'packages/sports/web/app/src/ui-manager/ui-manager.state';
import { UiStates } from 'packages/sports/web/app/src/ui-manager/ui-states.enum';
import { tap, withLatestFrom } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { RewardTokensActions } from '../actions';
import { RewardTokensDialogService } from '../services/reward-tokens-dialog.service';

@Injectable()
export class RewardTokensDialogEffects {
    constructor(
        private actions$: Actions,
        private store: Store<IBetslipRootState>,
        private dialogService: RewardTokensDialogService,
        private numpadDispalyService: NumpadDisplayService,
    ) {}

    openDialogEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(RewardTokensActions.openDialog),
                withLatestFrom(this.store.select(uiStateSelector)),
                tap(([action, uiState]) => {
                    this.numpadDispalyService.close();

                    const inColumn =
                        uiState.states.some((s) => s === UiStates.RightColumnVisible) && !uiState.states.some((s) => s === UiStates.QuickBetBuilder);
                    this.dialogService.openTokensDialog(inColumn, action);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    openInfoDialogEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(RewardTokensActions.showOverlayInfo),
                withLatestFrom(this.store.select(uiStateSelector)),
                tap(([action, uiState]) => {
                    const inColumn =
                        uiState.states.some((s) => s === UiStates.RightColumnVisible) && !uiState.states.some((s) => s === UiStates.QuickBetBuilder);
                    this.dialogService.openInfoDialog(inColumn, action.tokenContext);
                }),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    closeDialogEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(RewardTokensActions.closeDialog),
                tap(() => this.dialogService.closeTokensDialog()),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );

    closeInfoDialogEffect$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(RewardTokensActions.hideOverlayInfo),
                tap(() => this.dialogService.closeInfoDialog()),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );
}
